import React from 'react'
import Box from '@mui/material/Box'
import styled from 'styled-components'

import { ActionCardProps } from 'types/TextAnalysis'
import { CardCheckbox } from 'components/Shared/ActionCard/Header/CardCheckbox'
import { CardMeta } from 'components/Shared/ActionCard/Header/CardMeta'

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
`

const HeaderContainer = ({
  id,
  hover,
  showCheckbox,
  $checked,
  showAddTag,
  cardMeta,
  cardActions,
  handleCheckboxClick,
}: ActionCardProps) => {
  return (
    <Box className="ActionCard-CardHeader">
      <Wrapper>
        <CardCheckbox
          id={id}
          showCheckbox={showCheckbox}
          $checked={$checked}
          handleCheckboxClick={handleCheckboxClick}
        />
        <CardMeta cardMeta={cardMeta} />
      </Wrapper>
      <>{hover && showAddTag && cardActions}</>
    </Box>
  )
}

export default React.memo(HeaderContainer)
